"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetTableStatePersistFilteringAction = exports.resetTableStateAction = exports.setItemsPerPageAction = exports.setPageIsLoadingAction = exports.setCurrentPageAction = exports.setSelectedRowsAction = exports.setCurrentSortAction = exports.removeFilterAction = exports.setFilterAction = exports.TABLE_RESET_STATE_PERSIST_FILTERING = exports.TABLE_RESET_STATE = exports.TABLE_SET_PAGE_IS_LOADING = exports.TABLE_SET_ITEMS_PER_PAGE = exports.TABLE_SET_CURRENT_PAGE = exports.TABLE_SET_SELECTED_ROWS = exports.TABLE_REMOVE_FILTER = exports.TABLE_SET_FILTER = exports.TABLE_SET_CURRENT_SORT = void 0;
var table_model_1 = require("../models/table.model");
exports.TABLE_SET_CURRENT_SORT = 'TABLE_SET_CURRENT_SORT';
exports.TABLE_SET_FILTER = 'TABLE_SET_FILTER';
exports.TABLE_REMOVE_FILTER = 'TABLE_REMOVE_FILTER';
exports.TABLE_SET_SELECTED_ROWS = 'TABLE_SET_SELECTED_ROWS';
exports.TABLE_SET_CURRENT_PAGE = 'TABLE_SET_CURRENT_PAGE';
exports.TABLE_SET_ITEMS_PER_PAGE = 'TABLE_SET_ITEMS_PER_PAGE';
exports.TABLE_SET_PAGE_IS_LOADING = 'TABLE_SET_PAGE_IS_LOADING';
exports.TABLE_RESET_STATE = 'TABLE_RESET_STATE';
exports.TABLE_RESET_STATE_PERSIST_FILTERING = 'TABLE_RESET_STATE_PERSIST_FILTERING';
var setFilterAction = function (tableId, column, value) { return function (dispatch) { return dispatch({
    type: exports.TABLE_SET_FILTER,
    payload: { tableId: tableId, column: column, value: value },
}); }; };
exports.setFilterAction = setFilterAction;
var removeFilterAction = function (tableId, column) { return function (dispatch) { return dispatch({
    type: exports.TABLE_REMOVE_FILTER,
    payload: { tableId: tableId, column: column },
}); }; };
exports.removeFilterAction = removeFilterAction;
var setCurrentSortAction = function (tableId, currentSort) { return function (dispatch) { return dispatch({
    type: exports.TABLE_SET_CURRENT_SORT,
    payload: { tableId: tableId, currentSort: currentSort },
}); }; };
exports.setCurrentSortAction = setCurrentSortAction;
var setSelectedRowsAction = function (tableId, selectedRows) { return function (dispatch) { return dispatch({
    type: exports.TABLE_SET_SELECTED_ROWS,
    payload: { tableId: tableId, selectedRows: selectedRows },
}); }; };
exports.setSelectedRowsAction = setSelectedRowsAction;
var setCurrentPageAction = function (tableId, currentPage) { return function (dispatch) {
    dispatch({
        type: exports.TABLE_SET_CURRENT_PAGE,
        payload: { tableId: tableId, currentPage: currentPage },
    });
}; };
exports.setCurrentPageAction = setCurrentPageAction;
var setPageIsLoadingAction = function (tableId, pageIsLoading) { return function (dispatch) {
    dispatch({
        type: exports.TABLE_SET_PAGE_IS_LOADING,
        payload: { tableId: tableId, pageIsLoading: pageIsLoading },
    });
}; };
exports.setPageIsLoadingAction = setPageIsLoadingAction;
var setItemsPerPageAction = function (tableId, itemsPerPage) { return function (dispatch) { return dispatch({
    type: exports.TABLE_SET_ITEMS_PER_PAGE,
    payload: { tableId: tableId, itemsPerPage: itemsPerPage },
}); }; };
exports.setItemsPerPageAction = setItemsPerPageAction;
var resetTableStateAction = function (tableId) { return function (dispatch) { return dispatch({
    type: exports.TABLE_RESET_STATE,
    payload: { tableId: tableId },
}); }; };
exports.resetTableStateAction = resetTableStateAction;
var resetTableStatePersistFilteringAction = function (tableId) { return function (dispatch) { return dispatch({
    type: exports.TABLE_RESET_STATE_PERSIST_FILTERING,
    payload: { tableId: tableId },
}); }; };
exports.resetTableStatePersistFilteringAction = resetTableStatePersistFilteringAction;
// eslint-disable-next-line default-param-last
function tableReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k, _l, _m, _o;
    if (state === void 0) { state = (0, table_model_1.TableStateFactory)(); }
    var tableId = action.payload && action.payload.tableId;
    var defaultState = (0, table_model_1.TableObjectStateFactory)();
    switch (action.type) {
        case exports.TABLE_SET_CURRENT_SORT: return __assign(__assign({}, state), (_a = {}, _a[tableId] = __assign(__assign(__assign({}, defaultState), state[tableId]), { currentSort: action.payload.currentSort }), _a));
        case exports.TABLE_SET_FILTER: return __assign(__assign({}, state), (_b = {}, _b[tableId] = __assign(__assign(__assign({}, defaultState), state[tableId]), { filters: __assign(__assign({}, (_k = state[tableId]) === null || _k === void 0 ? void 0 : _k.filters), (_c = {}, _c[action.payload.column] = action.payload.value, _c)) }), _b));
        case exports.TABLE_REMOVE_FILTER: {
            var oldFilters = __assign({}, (_l = state[tableId]) === null || _l === void 0 ? void 0 : _l.filters);
            delete oldFilters[action.payload.column];
            return __assign(__assign({}, state), (_d = {}, _d[tableId] = __assign(__assign(__assign({}, defaultState), state[tableId]), { filters: __assign({}, oldFilters) }), _d));
        }
        case exports.TABLE_SET_SELECTED_ROWS: return __assign(__assign({}, state), (_e = {}, _e[tableId] = __assign(__assign(__assign({}, defaultState), state[tableId]), { selectedRows: action.payload.selectedRows }), _e));
        case exports.TABLE_SET_CURRENT_PAGE: {
            return __assign(__assign({}, state), (_f = {}, _f[tableId] = __assign(__assign(__assign({}, defaultState), state[tableId]), { currentPage: action.payload.currentPage }), _f));
        }
        case exports.TABLE_SET_PAGE_IS_LOADING: return __assign(__assign({}, state), (_g = {}, _g[tableId] = __assign(__assign(__assign({}, defaultState), state[tableId]), { pageIsLoading: action.payload.pageIsLoading }), _g));
        case exports.TABLE_SET_ITEMS_PER_PAGE: return __assign(__assign({}, state), (_h = {}, _h[tableId] = __assign(__assign(__assign({}, defaultState), state[tableId]), { itemsPerPage: action.payload.itemsPerPage }), _h));
        case exports.TABLE_RESET_STATE: {
            var cleanState = __assign({}, state);
            delete cleanState[tableId];
            return __assign({}, cleanState);
        }
        case exports.TABLE_RESET_STATE_PERSIST_FILTERING: return __assign(__assign({}, state), (_j = {}, _j[tableId] = __assign(__assign({}, (0, table_model_1.TableObjectStateFactory)()), { filters: ((_m = state[tableId]) === null || _m === void 0 ? void 0 : _m.filters) || {}, currentSort: (_o = state[tableId]) === null || _o === void 0 ? void 0 : _o.currentSort }), _j));
        default: return state;
    }
}
exports.default = tableReducer;
